/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const teacherSlice: any = createSlice({
  name: 'teacher',
  initialState: {
    teacherSelected: null,
    listTeacher: [],
    loading: false,
  },
  reducers: {
    setTeacherSelected: (state, action: PayloadAction<any>) => {
      state.teacherSelected = action.payload;
    },
    setListTeacher: (state, action: PayloadAction<any>) => {
      state.listTeacher = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const teacherAction = teacherSlice.actions;

export default teacherSlice.reducer;
